<template>
	<div>
		<hy-card>
			<div slot="head">
				<span>222</span>
			</div>
			<div>6666</div>
		</hy-card>
	</div>
</template>
<script>
	import hyCard from './../components/hy-card/index.vue'

	export default {
		data() {
			return {};
		},
		mounted() {
		},
		methods: {

		},
		watch: {},
		components: {
			hyCard
		},
		computed: {},
		updated() {},
		created() {}
	};
</script>
<style>

</style>
